<template>
  <form ref="form" method="POST" :action="action" target="_blank">
    <input v-for="field in fields" :key="field.name" type="hidden" :name="field.name" :value="field.value" />
  </form>
</template>

<script>
import CButton from "@/components/controls/button";

export default {
  components: { CButton },
  props: ["sp", "googleFormIsSubmitted"],

  computed: {
    action() {
      const { sp } = this;

      const params = {
        r: "google-sheets/create",
        worker_id: sp.userId,
        table: "personal_amount",
      };

      // if (sp.sort_by) {
      //   params.sort_by = sp.sort_by;
      //   params.sort_type = sp.sort_type;
      // }
      
      const search = Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
        
      return `/index.php?${search}`;
    },

    fields() {
      let params = {};

      if (this.sp.periodStart) {
        params = {
          date_user_search_type: "range",
          date_user_value: this.sp.periodStart,
          date_user_value_end: this.sp.periodEnd,
        };
      }

      if (this.sp.sort) params.sort = this.sp.sort

      params.is_delete = this.sp.is_delete

      if (this.sp.filters && this.sp.filters.columnFilters) {
        for (let filterName in this.sp.filters.columnFilters) {
          params[`${filterName}_search_type`] = this.sp.filters.columnFilters[filterName].searchType

          if (this.sp.filters.columnFilters[filterName].type === "date" && this.sp.filters.columnFilters[filterName].searchType === "range") {
            params[`${filterName}_value`] = this.sp.filters.columnFilters[filterName].value[0]
            params[`${filterName}_value_end`] = this.sp.filters.columnFilters[filterName].value[1]
          } else if (this.sp.filters.columnFilters[filterName].type === "number" && this.sp.filters.columnFilters[filterName].searchType === "4") {
            params[`${filterName}_value`] = this.sp.filters.columnFilters[filterName].value.start
            params[`${filterName}_value_end`] = this.sp.filters.columnFilters[filterName].value.end
          } else {
            params[`${filterName}_value`] = this.sp.filters.columnFilters[filterName].value
          }
        }
      }

      if (this.sp.filters && this.sp.filters.globalFilters) {
        for (let filterName in this.sp.filters.globalFilters) {
          params[`${filterName}_search_type`] = this.sp.filters.globalFilters[filterName].searchType

          if (this.sp.filters.globalFilters[filterName].type === "date" && this.sp.filters.globalFilters[filterName].searchType === "range") {
            params[`${filterName}_value`] = this.sp.filters.globalFilters[filterName].value[0]
            params[`${filterName}_value_end`] = this.sp.filters.globalFilters[filterName].value[1]
          } else if (this.sp.filters.globalFilters[filterName].type === "number" && this.sp.filters.globalFilters[filterName].searchType === "4") {
            params[`${filterName}_value`] = this.sp.filters.globalFilters[filterName].value.start
            params[`${filterName}_value_end`] = this.sp.filters.globalFilters[filterName].value.end
          } else {
            params[`${filterName}_value`] = this.sp.filters.globalFilters[filterName].value
          }
        }
      }

      const fields = Object.entries(params).map(([key, value]) => ({
        name: `params[${key}]`,
        value,
      }));
      
      return fields;
    },
  },
  watch: {
    googleFormIsSubmitted() {
      this.$refs.form.submit();
    }
  }
};
</script>
